import { render, staticRenderFns } from "./TelaNovaPedido.vue?vue&type=template&id=58f8e0e1&scoped=true&"
import script from "./TelaNovaPedido.vue?vue&type=script&lang=js&"
export * from "./TelaNovaPedido.vue?vue&type=script&lang=js&"
import style0 from "./TelaNovaPedido.vue?vue&type=style&index=0&id=58f8e0e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8e0e1",
  null
  
)

export default component.exports